export default "__VITE_ASSET__CnoaeHb7__"